import { LUSHA_INTEGRATIONS } from '../../components/SaveContact/constants';
import { BUTTON_TYPES } from '../../components/ShowContactByDataPoint/constants';
import { CONTACT_TYPES, DEFAULT_LIST_ID } from '../../const/contact';
import { CONTACT_STATES } from '../../utils/constants';
import { INDUSTRY_TO_DEMO_PROFILE } from '../user/selectors';
import { resolveContact } from './mappers';
export { selectContactCompanyLid, selectContactCompanyLinkedIn, selectContactCompanyName } from './companyLookup';
const hasValue = (dataPoint) => Boolean(dataPoint === null || dataPoint === void 0 ? void 0 : dataPoint.value);
export const selectContactById = (state, contactId) => contactId ? state.contacts[contactId] : undefined;
export const selectContactByKey = (state, contactWithId) => resolveContact(state.contacts, contactWithId);
export const selectTotalEmailsCollected = (contact) => Number(hasValue(contact === null || contact === void 0 ? void 0 : contact.email1)) + Number(hasValue(contact === null || contact === void 0 ? void 0 : contact.email2));
export const selectTotalPhonesCollected = (contact) => Number(hasValue(contact === null || contact === void 0 ? void 0 : contact.phone1)) + Number(hasValue(contact === null || contact === void 0 ? void 0 : contact.phone2));
export const selectTotalDataCollected = (contact) => selectTotalEmailsCollected(contact) + selectTotalPhonesCollected(contact);
/** Mirrors MST Contact.isEmpty. */
export const selectIsEmpty = (contact) => {
    var _a, _b;
    if (!contact) {
        return true;
    }
    const hasNoDatapoints = !hasValue(contact.email1) && !hasValue(contact.email2) && !hasValue(contact.phone1) && !hasValue(contact.phone2);
    const hasCompany = Boolean(contact.companyLid) || Boolean((_b = (_a = contact.wishlistData) === null || _a === void 0 ? void 0 : _a.company) === null || _b === void 0 ? void 0 : _b.hasCompany);
    return !contact.fullName || (hasNoDatapoints && !hasCompany);
};
/** Mirrors MST Contact.isWithoutData. */
export const selectIsWithoutData = (contact) => {
    var _a, _b, _c, _d;
    const isWishlistContact = selectIsWishlistContact(contact);
    if (!isWishlistContact) {
        return selectTotalDataCollected(contact) === 0;
    }
    return (!((_a = contact === null || contact === void 0 ? void 0 : contact.wishlistData) === null || _a === void 0 ? void 0 : _a.email1) &&
        !((_b = contact === null || contact === void 0 ? void 0 : contact.wishlistData) === null || _b === void 0 ? void 0 : _b.email2) &&
        !((_c = contact === null || contact === void 0 ? void 0 : contact.wishlistData) === null || _c === void 0 ? void 0 : _c.phone1) &&
        !((_d = contact === null || contact === void 0 ? void 0 : contact.wishlistData) === null || _d === void 0 ? void 0 : _d.phone2));
};
/** Mirrors MST Contact.isWishlistContact. */
export const selectIsWishlistContact = (contact) => {
    var _a, _b, _c, _d, _e;
    if (!(contact === null || contact === void 0 ? void 0 : contact.wishlistData)) {
        return false;
    }
    const isEmpty = !contact.fullName ||
        (!((_a = contact.email1) === null || _a === void 0 ? void 0 : _a.value) && !((_b = contact.email2) === null || _b === void 0 ? void 0 : _b.value) && !((_c = contact.phone1) === null || _c === void 0 ? void 0 : _c.value) && !((_d = contact.phone2) === null || _d === void 0 ? void 0 : _d.value));
    return (isEmpty || (Boolean(contact.isPartialProfile) && Boolean((_e = contact.wishlistData.lists) === null || _e === void 0 ? void 0 : _e.length) && !contact.isRevealed));
};
/** Mirrors MST Contact.contactType. */
export const selectContactType = (contact) => {
    if (!contact) {
        return null;
    }
    if (selectIsWishlistContact(contact)) {
        return CONTACT_TYPES.WISHLIST_CONTACT;
    }
    if (contact.isRevealed) {
        return CONTACT_TYPES.SHOWN_CONTACT;
    }
    return null;
};
export const selectHasEmailDataPoint = (contact) => hasValue(contact === null || contact === void 0 ? void 0 : contact.email1) || hasValue(contact === null || contact === void 0 ? void 0 : contact.email2);
export const selectHasPhoneDataPoint = (contact) => hasValue(contact === null || contact === void 0 ? void 0 : contact.phone1) || hasValue(contact === null || contact === void 0 ? void 0 : contact.phone2);
/** Mirrors MST Contact.hasWorkEmail. */
export const selectHasWorkEmail = (contact) => {
    var _a, _b;
    return (hasValue(contact === null || contact === void 0 ? void 0 : contact.email1) && ((_a = contact === null || contact === void 0 ? void 0 : contact.email1) === null || _a === void 0 ? void 0 : _a.type) === 'Work') ||
        (hasValue(contact === null || contact === void 0 ? void 0 : contact.email2) && ((_b = contact === null || contact === void 0 ? void 0 : contact.email2) === null || _b === void 0 ? void 0 : _b.type) === 'Work');
};
/** Mirrors MST Contact.hasDirectEmail. */
export const selectHasDirectEmail = (contact) => {
    var _a, _b;
    return (hasValue(contact === null || contact === void 0 ? void 0 : contact.email1) && ((_a = contact === null || contact === void 0 ? void 0 : contact.email1) === null || _a === void 0 ? void 0 : _a.type) === 'Direct') ||
        (hasValue(contact === null || contact === void 0 ? void 0 : contact.email2) && ((_b = contact === null || contact === void 0 ? void 0 : contact.email2) === null || _b === void 0 ? void 0 : _b.type) === 'Direct');
};
/** Mirrors MST Contact.emails view. */
export const selectEmails = (contact) => {
    const emails = [];
    if ((contact === null || contact === void 0 ? void 0 : contact.email1) && hasValue(contact.email1)) {
        emails.push(contact.email1);
    }
    if ((contact === null || contact === void 0 ? void 0 : contact.email2) && hasValue(contact.email2)) {
        emails.push(contact.email2);
    }
    return emails;
};
/** Mirrors MST Contact.phones view. */
export const selectPhones = (contact) => {
    const phones = [];
    if ((contact === null || contact === void 0 ? void 0 : contact.phone1) && hasValue(contact.phone1)) {
        phones.push(contact.phone1);
    }
    if ((contact === null || contact === void 0 ? void 0 : contact.phone2) && hasValue(contact.phone2)) {
        phones.push(contact.phone2);
    }
    return phones;
};
/** Mirrors MST ContactData.isMiss: the waterfall searched vendors and came back empty. */
export const selectIsDataPointMiss = (dataPoint) => { var _a; return (dataPoint === null || dataPoint === void 0 ? void 0 : dataPoint.status) === CONTACT_STATES.MISS && Boolean((_a = dataPoint === null || dataPoint === void 0 ? void 0 : dataPoint.vendors) === null || _a === void 0 ? void 0 : _a.length) && !(dataPoint === null || dataPoint === void 0 ? void 0 : dataPoint.value); };
/** Mirrors MST Contact.missedEmails. */
export const selectMissedEmails = (contact) => [contact === null || contact === void 0 ? void 0 : contact.email1, contact === null || contact === void 0 ? void 0 : contact.email2].filter((email) => selectIsDataPointMiss(email));
/** Mirrors MST Contact.missedPhones. */
export const selectMissedPhones = (contact) => [contact === null || contact === void 0 ? void 0 : contact.phone1, contact === null || contact === void 0 ? void 0 : contact.phone2].filter((phone) => selectIsDataPointMiss(phone));
/** Mirrors MST Contact.hasOnlyMaskedData. */
export const selectHasOnlyMaskedData = (contact) => {
    if (selectTotalDataCollected(contact) === 0) {
        return false;
    }
    const emails = selectEmails(contact);
    const phones = selectPhones(contact);
    const allEmailsMasked = emails.length === 0 || emails.every(email => email.status === 'masked');
    const allPhonesMasked = phones.length === 0 || phones.every(phone => phone.status === 'masked');
    return allEmailsMasked && allPhonesMasked;
};
export const selectHasChanges = (contact) => (contact === null || contact === void 0 ? void 0 : contact.state) === CONTACT_STATES.REFRESHED;
export const selectIsSavedToList = (contact) => (contact === null || contact === void 0 ? void 0 : contact.contactList) ? contact.contactList !== DEFAULT_LIST_ID : false;
/** Mirrors MST Contact.isNotAllDataPointsSaved. */
export const selectIsNotAllDataPointsSaved = (contact) => {
    const savedDatapoints = contact === null || contact === void 0 ? void 0 : contact.savedDatapoints;
    if (!(savedDatapoints === null || savedDatapoints === void 0 ? void 0 : savedDatapoints.length)) {
        return false;
    }
    const revealedDatapoints = [contact.phone1, contact.phone2, contact.email1, contact.email2]
        .map(dataPoint => (!dataPoint || !dataPoint.isRevealed ? null : dataPoint.id))
        .filter((id) => Boolean(id));
    return revealedDatapoints.some(datapointId => !savedDatapoints.includes(datapointId));
};
export const selectSavedCrmIntegrations = (contact) => Object.keys((contact === null || contact === void 0 ? void 0 : contact.integrationsData) || {});
export const selectSavedIntegrations = (contact) => {
    const savedCrm = selectSavedCrmIntegrations(contact);
    return selectIsSavedToList(contact) ? savedCrm.concat([LUSHA_INTEGRATIONS.Lusha]) : savedCrm;
};
export const selectCrmIndicationIntegrations = (contact) => {
    const savedIntegrations = new Set(selectSavedCrmIntegrations(contact).map(name => name.toLowerCase()));
    return ((contact === null || contact === void 0 ? void 0 : contact.crmExistingIntegrations) || []).filter(name => !savedIntegrations.has(name.toLowerCase()));
};
/** Mirrors MST Contact.wishlistContactDetails. */
export const selectWishlistContactDetails = (contact) => {
    const details = [];
    const wishlistData = contact === null || contact === void 0 ? void 0 : contact.wishlistData;
    if (!wishlistData) {
        return details;
    }
    if (wishlistData.email1) {
        details.push({ label: 'Email', key: 'email1', data: wishlistData.email1 });
    }
    if (wishlistData.email2) {
        details.push({ label: 'Email', key: 'email2', data: wishlistData.email2 });
    }
    if (wishlistData.phone1) {
        details.push({ label: 'Phone', key: 'phone1', data: wishlistData.phone1 });
    }
    if (wishlistData.phone2) {
        details.push({ label: 'Phone', key: 'phone2', data: wishlistData.phone2 });
    }
    return details;
};
/** Mirrors MST Contact.emailsForActions. */
export const selectEmailsForActions = (contact) => {
    var _a, _b;
    if (selectIsWishlistContact(contact)) {
        return ((_b = (_a = contact === null || contact === void 0 ? void 0 : contact.wishlistData) === null || _a === void 0 ? void 0 : _a.emails) !== null && _b !== void 0 ? _b : []).filter(email => email === null || email === void 0 ? void 0 : email.value);
    }
    return selectEmails(contact);
};
/** Mirrors MST Contact.hasOnlyDncPhones. */
export const selectHasOnlyDncPhones = (contact) => {
    var _a, _b;
    const emails = selectEmails(contact);
    const phones = selectPhones(contact);
    const hasEmails = emails.length > 0;
    const hasMultiplePhones = phones.length === 2;
    return (!hasEmails && Boolean((_a = contact === null || contact === void 0 ? void 0 : contact.phone1) === null || _a === void 0 ? void 0 : _a.isDncPhone) && (Boolean((_b = contact === null || contact === void 0 ? void 0 : contact.phone2) === null || _b === void 0 ? void 0 : _b.isDncPhone) || !hasMultiplePhones));
};
/** Mirrors MST Contact.hasDncPhone. */
export const selectHasDncPhone = (contact) => { var _a, _b; return Boolean(((_a = contact === null || contact === void 0 ? void 0 : contact.phone1) === null || _a === void 0 ? void 0 : _a.isDncPhone) || ((_b = contact === null || contact === void 0 ? void 0 : contact.phone2) === null || _b === void 0 ? void 0 : _b.isDncPhone)); };
/** Mirrors MST Contact.contactHasMaskedEmails. */
export const selectContactHasMaskedEmails = (contact) => selectEmails(contact).some(email => email.status === 'masked');
/** Mirrors MST Contact.contactHasMaskedPhones. */
export const selectContactHasMaskedPhones = (contact) => selectPhones(contact).some(phone => phone.status === 'masked');
/** Mirrors MST Contact.isNotEligibleToBeShown. */
export const selectIsNotEligibleToBeShown = (contact) => Boolean(contact === null || contact === void 0 ? void 0 : contact.isBlockedForShow) || selectHasOnlyDncPhones(contact);
/** Mirrors MST Contact.dataPointToShow. */
export const selectDataPointToShow = (contact) => {
    const emails = selectEmails(contact);
    const phones = selectPhones(contact);
    const hasEmailToShow = emails.some(email => email.status === 'masked');
    const hasPhoneToShow = phones.some(phone => phone.status === 'masked');
    if (hasEmailToShow && hasPhoneToShow) {
        return BUTTON_TYPES.EMAIL_AND_PHONE;
    }
    if (hasEmailToShow) {
        return BUTTON_TYPES.EMAIL;
    }
    if (hasPhoneToShow) {
        return BUTTON_TYPES.PHONE;
    }
    return BUTTON_TYPES.NONE;
};
/** Mirrors MST Contact.canAddData when not currently adding. */
export const selectCanAddData = (contact, isAddingData = false) => {
    var _a, _b, _c, _d, _e, _f;
    if (!contact || isAddingData) {
        return false;
    }
    if (selectIsWishlistContact(contact)) {
        const emailsLen = (_c = (_b = (_a = contact.wishlistData) === null || _a === void 0 ? void 0 : _a.emails) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        const phonesLen = (_f = (_e = (_d = contact.wishlistData) === null || _d === void 0 ? void 0 : _d.phones) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0;
        return emailsLen === 0 || phonesLen === 0;
    }
    const onboardingProfiles = Object.values(INDUSTRY_TO_DEMO_PROFILE);
    const isOnboardingProfile = Boolean(contact.isOnboarding) || onboardingProfiles.some(profile => (contact.socialLink || '').includes(profile));
    if (isOnboardingProfile) {
        return false;
    }
    if (!contact.isRevealed) {
        return false;
    }
    return selectEmails(contact).length < 2 || selectPhones(contact).length < 2;
};
